export const baseApiUrl = 'https://api.mgcash.app.br'
export const baseAuthApiUrl = 'https://api-auth.mgcash.app.br/'

export const baseFrotendUrl = 'https://mgcash.app.br'
export const baseFrotendAuth = 'https://auth.mgcash.app.br/#/'
